import React, { useState } from "react";

// App
import { ApiPath, Notice, Section } from "./apiField";

// UI components
import { X } from "react-feather";

function Lightbox({ image, onClose }) {
  if (!image) return null;

  return (
    <div
      className="rhp-lightbox"
      role="presentation"
      onClick={onClose}
    >
      <button type="button" className="rhp-lightbox__close" onClick={onClose}>
        <X size={20} />
      </button>
      <figure onClick={(e) => e.stopPropagation()}>
        <img src={image.url} alt={image.alt || ""} />
        <figcaption>
          <span>{image.caption || image.alt || image.id}</span>
          <ApiPath path={image.path} />
        </figcaption>
      </figure>
    </div>
  );
}

export default function GallerySection({ meetingGallery, hotelGalleries, tour, raw }) {
  const [active, setActive] = useState(null);

  return (
    <>
      <Section
        id="gallery"
        title="Meeting room gallery"
        subtitle={`${meetingGallery.images.length} images · ${meetingGallery.sources.length} sources`}
        path="roomInfo / gallery / images"
        raw={raw}
      >
        {!meetingGallery.images.length ? (
          <Notice tone="warn">No meeting room images.</Notice>
        ) : (
          <>
            <ul className="rhp-sources">
              {meetingGallery.sources.map((source) => (
                <li key={source.label}>
                  <span className="rhp-sources__count">
                    {source.images.length}
                  </span>
                  <span className="rhp-sources__label">{source.label}</span>
                  <ApiPath path={source.path} />
                </li>
              ))}
            </ul>

            <div className="rhp-gallery">
              {meetingGallery.images.map((img, i) => (
                <button
                  type="button"
                  className="rhp-gallery__item"
                  key={`${img.url}-${i}`}
                  onClick={() => setActive(img)}
                >
                  <img src={img.thumb} alt={img.alt || ""} loading="lazy" />
                  {img.caption ? <span>{img.caption}</span> : null}
                </button>
              ))}
            </div>
          </>
        )}

        {tour?.url ? (
          <div className="rhp-tour">
            <a href={tour.url} target="_blank" rel="noopener noreferrer">
              3D tour
            </a>
            <ApiPath path={tour.path} />
          </div>
        ) : null}
      </Section>

      {hotelGalleries.length ? (
        <Section
          id="hotel-gallery"
          title="Full hotel gallery"
          subtitle={`${hotelGalleries.length} categories`}
          path="gallery.collection[0].content.gallery.values[]"
        >
          {hotelGalleries.map((group) => (
            <div className="rhp-gallery-group" key={group.index}>
              <h3 className="rhp-subhead">
                {group.label || "Uncategorised"}
                <span className="rhp-subhead__count">
                  {group.images.length}
                </span>
              </h3>
              <ApiPath path={group.path} />
              <div className="rhp-gallery rhp-gallery--sm">
                {group.images.map((img, i) => (
                  <button
                    type="button"
                    className="rhp-gallery__item"
                    key={`${img.url}-${i}`}
                    onClick={() => setActive(img)}
                  >
                    <img src={img.thumb} alt={img.alt || ""} loading="lazy" />
                  </button>
                ))}
              </div>
            </div>
          ))}
        </Section>
      ) : null}

      <Lightbox image={active} onClose={() => setActive(null)} />
    </>
  );
}
